import JwtService from '@/common/jwt.service'

export default function auth(to, from, next) {
  if (!JwtService.getUser()) {
    // return router.push({ name: 'login' })
    return next('/login')
  }
  return next()
}
